import { URLS } from 'config';

export const QUERY_URLS = [
  URLS.enquiryWelcome,
  URLS.enquiryContactDetails,
  URLS.enquiryWorkDetails,
  URLS.enquiryProjectBudget,
  URLS.enquiryComplete,
];

export const QUOTE_URLS = [
  URLS.enquiryQuoteWelcome,
  URLS.enquiryQuoteContactDetails,
  URLS.enquiryQuoteUploadQuote,
  URLS.enquiryQuoteConfirmDetails,
  URLS.enquiryQuoteComplete,
];
